import React, { useState } from 'react';

function useVariables(envVariables, hasChanged) {
  const [variable, setVariable] = useState({
    key: '',
    staging: '',
    production: '',
  });

  const handleNewVariable = React.useCallback(itemType => e => {
    let { value } = e.target;

    if (itemType === 'key') {
      value = value.toUpperCase().replace(/[^A-Z_]/g, '');
    } else if (itemType === 'staging' || itemType === 'production') {
      value = value.replace(/ /g, '');
    }

    if (value.length > 1000) return;

    setVariable({ ...variable, [itemType]: value });
  });

  const handleAddVariable = React.useCallback(
    (itemKey, itemStaging, itemProduction) => () => {
      const newVariable = {
        key: itemKey,
        staging: itemStaging,
        production: itemProduction,
      };

      const allVariables = [...envVariables];
      allVariables.unshift(newVariable);
      setVariable({ key: '', staging: '', production: '' });
      hasChanged(allVariables);
    }
  );

  const handleEditVariable = React.useCallback((item, i, itemType) => e => {
    const allVariables = [...envVariables];
    let { value } = e.target;

    if (itemType === 'key') {
      value = value.toUpperCase().replace(/[^A-Z_]/g, '');
    } else if (itemType === 'staging' || itemType === 'production') {
      value = value.replace(/ /g, '');
    }

    if (value.length > 1000 || value === item[itemType]) return;

    allVariables[i] = {
      ...allVariables[i],
      [itemType]: value,
    };

    hasChanged(allVariables);
  });

  const handleDeleteVariable = React.useCallback(i => () => {
    const allVariables = [...envVariables];
    allVariables.splice(i, 1);
    hasChanged(allVariables);
  });

  return {
    variable,
    handleNewVariable,
    handleAddVariable,
    handleEditVariable,
    handleDeleteVariable,
  };
}

export default useVariables;
